module.exports = __webpack_public_path__ + "static/img/home2.8b06556a.jpg";